import { Component, Input } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { trigger, state, style, transition, animate } from "@angular/animations";

export interface ITimelineIssueCitation {
    text: string;
    iconPath: string;
}

export interface ITimelineIssueItem {
    date: string;
    time: string;
    text: string; // Rich text in HTML format
    innerText?: string; // Additional details with <red> tags for styling
    iconPath?: string;
    showInnerText?: boolean;
    isLoading?: boolean;
    citations?: ITimelineIssueCitation[];
    tag?: string;
}

@Component({
    selector: "app-timeline-issue",
    templateUrl: "./timeline-issue.component.html",
    styleUrls: ["./timeline-issue.component.scss"],
    animations: [
        trigger("slideInOutAnimation", [
            state(
                "in",
                style({
                    height: "*",
                    opacity: 1,
                    transform: "translateY(0)",
                }),
            ),
            transition(":enter", [style({ height: "0px", opacity: 0, transform: "translateY(-10px)" }), animate("300ms ease-in-out")]),
            transition(":leave", [animate("300ms ease-in-out", style({ height: "0px", opacity: 0, transform: "translateY(-10px)" }))]),
        ]),
    ],
})
export class TimelineIssueComponent {
    @Input() public timelineIssueItems: ITimelineIssueItem[] = [];

    constructor(private _sanitizer: DomSanitizer) {}

    public parseText(text: string): SafeHtml {
        const parsedText = text.replace(
            /<code>(.*?)<\/code>/g,
            `<span style="background-color:rgb(250, 247, 255); color: #6e32e0;
            padding: 2px 2px; border-radius: 2px; border: 1px solid #6e32e03d; ">$1</span>`,
        );
        return this._sanitizer.bypassSecurityTrustHtml(parsedText);
    }

    public toggleInnerText(index: number): void {
        const item = this.timelineIssueItems[index];
        item.showInnerText = !item.showInnerText;

        const delay = this._getRandomDelay(550, 650);

        if (item.showInnerText && item.isLoading === undefined) {
            item.isLoading = true;

            // Simulate HTTP request delay
            setTimeout(() => {
                item.isLoading = false;
            }, delay); // ms delay for loading
        }
    }

    public parseInnerText(innerText: string | undefined): SafeHtml {
        if (!innerText) {
            return "";
        }

        // Replace <red> tags with inline-styled spans
        const parsedText = innerText.replace(
            /<red>(.*?)<\/red>/g,
            `<span style="background-color: #ffe6e6; color: #d9534f;
            padding: 2px 4px; border-radius: 2px; display: inline-block;">$1</span>`,
        );
        return this._sanitizer.bypassSecurityTrustHtml(parsedText);
    }

    public expandAllTimelineItems(): void {
        this.timelineIssueItems.forEach((item) => {
            if (item.innerText && !item.showInnerText) {
                item.showInnerText = true;

                if (item.isLoading === undefined) {
                    item.isLoading = true;

                    // Simulate HTTP request delay
                    const delay = this._getRandomDelay(400, 1100);
                    setTimeout(() => {
                        item.isLoading = false;
                    }, delay);
                }
            }
        });
    }

    private _getRandomDelay(min: number, max: number): number {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
}
